"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatStripeShippingAddress = void 0;
const src_1 = require("..");
function formatStripeShippingAddress(address) {
    var _a, _b, _c, _d, _e, _f;
    const countryIso = (_a = address.country) !== null && _a !== void 0 ? _a : '';
    const region = (_b = address.region) !== null && _b !== void 0 ? _b : '';
    const { code: provinceCode, name: provinceName } = (0, src_1.getProvinceDetails)(countryIso, region);
    const countryName = (0, src_1.getCountryName)(countryIso);
    const { firstName, lastName } = (0, src_1.getFirstAndLastName)(address.recipient);
    const formattedAddress = {
        'first_name': firstName,
        'last_name': lastName,
        'address_line_1': (address.addressLine && address.addressLine[0]) ? address.addressLine[0] : '',
        'address_line_2': (address.addressLine && address.addressLine[1]) ? address.addressLine[1] : '',
        'country': countryName,
        'city': (_c = address.city) !== null && _c !== void 0 ? _c : '',
        'province': provinceName,
        'country_code': countryIso,
        'province_code': provinceCode,
        'postal_code': (_d = address.postalCode) !== null && _d !== void 0 ? _d : '',
        'business_name': (_e = address.organization) !== null && _e !== void 0 ? _e : '',
        'phone_number': (_f = address.phone) !== null && _f !== void 0 ? _f : ''
    };
    if (formattedAddress.postal_code.length <= 4 && formattedAddress.country_code === 'CA') {
        formattedAddress.postal_code += '1A1'; //adding default postal code because stripe only provide first 3 digits until the payment is done.
    }
    return formattedAddress;
}
exports.formatStripeShippingAddress = formatStripeShippingAddress;
